module.exports = __webpack_public_path__ + "media/ג.45a46f00.mp3";